var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExploreArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1323_13146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.31574 9.66668C1.51241 9.66668 1.69735 9.59004 1.83671 9.45092L5.76655 5.521C5.90568 5.38182 5.98242 5.19678 5.98242 4.99997C5.98242 4.80317 5.90566 4.61811 5.76655 4.47895L1.83671 0.549104C1.6976 0.409924 1.51243 0.333344 1.31574 0.333344C1.11904 0.333344 0.933872 0.409924 0.794765 0.549031C0.655641 0.688265 0.578896 0.87331 0.578896 1.07013C0.578896 1.26695 0.655659 1.45199 0.794765 1.59116L4.20366 4.99997L0.794785 8.40879C0.655659 8.54797 0.578914 8.73302 0.578914 8.92982C0.578914 9.12662 0.655678 9.31168 0.794785 9.45084C0.934128 9.59004 1.11906 9.66668 1.31574 9.66668Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.7542 9.66668C4.95089 9.66668 5.1358 9.59004 5.27517 9.45092L9.20503 5.52102C9.34415 5.38184 9.4209 5.19679 9.4209 4.99999C9.4209 4.80319 9.34414 4.61813 9.20503 4.47897L5.27519 0.549122C5.13606 0.409924 4.95089 0.333344 4.7542 0.333344C4.5575 0.333344 4.37233 0.409924 4.23322 0.549031C4.0941 0.688265 4.01735 0.87331 4.01735 1.07013C4.01735 1.26695 4.0941 1.45199 4.23322 1.59116L7.6421 4.99997L4.23322 8.40879C4.0941 8.54797 4.01735 8.73302 4.01735 8.92982C4.01735 9.12662 4.09412 9.31168 4.23322 9.45084C4.37259 9.59004 4.55752 9.66668 4.7542 9.66668Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1323_13146"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.33333,
    height: 9.33333,
    fill: "white",
    transform: "matrix(-1 0 0 1 9.6665 0.333344)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreArrow);
export default __webpack_public_path__ + "static/media/exploreArrow.2413d2cd1fe4c2947c48c0e47cebe53e.svg";
export { ForwardRef as ReactComponent };